import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { InspectionStandardTypes } from '../../../utils/enums/InspectionStandardTypes';
import { isCustomerVersion } from '../../../utils/isCustomerVersion';
import { CollapsiblePanel, EditPanel, EditPanelCell, EditPanelRow, EditPanelSelect, PanelBody, PanelButton } from '../../elements';

interface ISurveyEditGenerateReportProps {
    surveyId: string;
    surveyInspectionStandardType: InspectionStandardTypes;
}

export function SurveyEditGenerateReport(props: ISurveyEditGenerateReportProps) {
    const translate = useTranslate();
    const [languageCode, setLanguageCode] = React.useState('en');

    function downloadExport() {
        const url = `/api/generateReport/${props.surveyId}?languageCode=${languageCode}`;
        window.open(url);
    }

    if (!isCustomerVersion('ronik') || props.surveyInspectionStandardType === InspectionStandardTypes.Fmeca) {
        return null;
    }

    const languageOptions = [{ value: 'en', text: translate('user.english') }];
    if (props.surveyInspectionStandardType !== InspectionStandardTypes.Api653) {
        languageOptions.push({ value: 'nl', text: translate('user.dutch') });
    }

    return (
        <EditPanel bottomMargin={true} noPadding={true}>
            <CollapsiblePanel
                heading={{
                    dark: true,
                    text: translate('survey.generateReportTab'),
                    initialIsClosed: true,
                }}
            >
                <PanelBody isForm={true}>
                    <EditPanelRow>
                        <EditPanelCell rowCount={4}>
                            <EditPanelSelect
                                name="languageCode"
                                value={languageCode}
                                handleChange={(value) => setLanguageCode(value)}
                                options={languageOptions}
                            />
                        </EditPanelCell>
                        <EditPanelCell rowCount={4}>
                            <PanelButton onClick={downloadExport} primary text="Download" />
                        </EditPanelCell>
                    </EditPanelRow>
                </PanelBody>
            </CollapsiblePanel>
        </EditPanel>
    );
}
